export default (that) => [
  {
    text: that.$l('INDEX.btn_tips_view') || '查看',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('INDEX.btn_tips_edit') || '编辑',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ inputStandardStatus }) => !['Y'].includes(inputStandardStatus),
  },
  {
    text: that.$l('INDEX.btn_tips_del') || '删除',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ inputStandardStatus }) => !['Y'].includes(inputStandardStatus),
  },
]
